import React, { Component, Suspense, lazy } from 'react';
import { Router, Switch } from 'react-router-dom';
import history from './history';
import { DefaultLayout, DigiCore, AdminLayout, ThirdPartyAdmin, LoginLayout, DistributorLayout ,ExternalLayout} from '../containers/Layouts';
import Dashboard from '../containers/Dashboard';
import Loader from '../components/Loader';
import Systems from '../containers/Systems';
import AccountDetails from '../containers/AccountDetails';
import Account from '../containers/Account';
import { FLEET_DASHBOARD_URL } from '../config/constants';
const ScrollToTop = lazy(() => import('../components/ScrollToTop'));
const AreaCoverage = lazy(() => import('../containers/AreaCoverage'));
const NoMatch = lazy(() => import('../components/NoMatch'));
const RedirectToLeadView = lazy(() => import('../containers/LeadManagement/RedirectToLeadView'));
const EinProgram = lazy(() => import('../containers/EinProgram'));
const Branches = lazy(() => import('../containers/Branches'));
const Users = lazy(() => import('../containers/Users'));
const UserForm = lazy(() => import('../containers/UserForm'));
const APIAccess = lazy(() => import('../containers/APIAccess'));
const GridProfile = lazy(() => import('../containers/GridProfile'));
const ThirdPartyReporting = lazy(() => import('../containers/ThirdPartyReporting'));
const PlatformDiscounts = lazy(() => import('../containers/PlatformDiscounts'));
const ActivationUI = lazy(() => import('../containers/ActivationUI'));
const ErrorComponent = lazy(() => import('../components/ErrorComponent'));
const MerchandiseCredit = lazy(() => import('../containers/MerchandiseCredit'));
const TrainingDashboard = lazy(() => import('../containers/TrainingDashboard'));
const FleetDashboard = lazy(() => import('../containers/FleetDashboard'));
const EinDashboard = lazy(() => import('../containers/EinDashboard'));
const LeadPreferences = lazy(() => import('../containers/LeadPreferences'));
const BOM = lazy(() => import('../containers/BOM'));
const ModemReplacement = lazy(() => import('../containers/ModemReplacement'));
const RMADashboard = lazy(() => import('../containers/RMADashboard'));
const PermittingListing = lazy(() => import('../containers/Permitting/Listing'));
const PermittingAssistance = lazy(() => import('../containers/Permitting'));
const PermitChats = lazy(() => import('../containers/Permitting/Chats'));
const Registration = lazy(() => import('../containers/Registration'));
const AdminNew = lazy(() => import('../containers/AdminNew'));
const CommercialShortcuts = lazy(() => import('../containers/CommercialShortcuts'));
const SGMarketingPage = lazy(() => import('../containers/SGMarketingPage'));
const SGIPIncentive = lazy(() => import('../containers/SGIPIncentive'));
const SGIPApplications = lazy(() => import('../containers/SGIPIncentive/Applications'));
const SGIPNewApplication = lazy(() => import('../containers/SGIPIncentive/NewApplication'));
const LeadListing = lazy(() => import('../containers/LeadManagement/LeadListing'));
const LeadView = lazy(() => import('../containers/LeadManagement/LeadView'));
const CompanyProfile = lazy(() => import('../containers/CompanyProfile'));
const Preferences = lazy(() => import('../containers/PreferenceSettings'));
const AuthorizedSubcontractor = lazy(() => import('../containers/AuthorizedDealer'));
const GeneratorTokensInstaller = lazy(() => import('../containers/GeneratorTokensInstaller'));
const GeneratorTokensDistributor = lazy(() => import('../containers/GeneratorTokensDistributor'));
const Pronto = lazy(()=> import('../containers/Pronto'));
const CellModemDataPlanExtension = lazy(()=> import('../containers/CellModemDataPlanExtension'));
const DeviceReplacement = lazy(()=>import('../containers/DeviceReplacement'));
export default class Routes extends Component {
  render() {
    return (
      <Router history={history}>
        <Suspense
          fallback={
            <div>
              <Loader loading={true} />
            </div>
          }
        >
          <ScrollToTop />
          <Switch>
            <DefaultLayout exact path="/manager" component={NoMatch} />

            {/* account */}
            <DefaultLayout exact path="/manager/account" component={Account} />
            <DefaultLayout exact path="/manager/account/area-coverage" component={AreaCoverage} />
            <DefaultLayout exact path="/manager/account/lead-program" component={LeadPreferences} />
            <DefaultLayout exact path="/manager/account/ein-program" component={EinProgram} />
            <DefaultLayout
              exact
              path="/manager/account/company"
              component={props => <CompanyProfile isFrom="company" {...props} />}
            />
            <DefaultLayout exact path="/manager/account/branches" component={Branches} />
            <DefaultLayout
              exact
              path="/manager/account/branches/create"
              component={props => <CompanyProfile isFrom="createBranch" {...props} />}
            />
            <DefaultLayout
              exact
              path="/manager/account/branches/:companyId"
              component={props => <CompanyProfile isFrom="editBranch" {...props} />}
            />
            <DefaultLayout exact path="/manager/account/users" component={Users} />
            <DefaultLayout
              exact
              path="/manager/dashboard/authorized-subcontractor"
              component={AuthorizedSubcontractor}
            />
            <DefaultLayout
              exact
              path="/manager/account/users/create"
              component={props => <UserForm isFrom="createUser" {...props} />}
            />
            <DefaultLayout
              exact
              path="/manager/account/users/:userId"
              component={props => <UserForm isFrom="editUser" {...props} />}
            />
            <DefaultLayout exact path="/manager/account/preferences" component={Preferences} />
            <DefaultLayout exact path="/manager/account/api-access" component={APIAccess} />
            <DefaultLayout exact path="/manager/account/third-party-reporting" component={ThirdPartyReporting} />
            <DefaultLayout exact path="/manager/account/account-details" component={AccountDetails} />
            <DefaultLayout exact path="/manager/account/profiles" component={GridProfile} />
            <DefaultLayout exact path="/manager/account/companies/:companyId/users" component={Users} />
            <DefaultLayout exact path="/manager/company/:companyId/area-coverage" component={AreaCoverage} />
            <DefaultLayout exact path="/manager/company/:companyId/ein-program" component={EinProgram} />
            <DefaultLayout exact path="/manager/account/labor-protection" component={props => <Systems {...props} />} />

            <DefaultLayout exact path="/manager/account/permitting-assistance" component={PermittingListing} />
            <DefaultLayout
              exact
              path="/manager/account/:source_id/permitting-assistance/:permit_id"
              component={props => <PermittingAssistance {...props} />}
              hasLeftPane
              withoutFooter
            />
            <DefaultLayout
              exact
              path="/manager/account/permitting-assistance/:permit_id"
              component={props => <PermittingAssistance {...props} />}
              hasLeftPane
              withoutFooter
            />
            <DefaultLayout
              exact
              path="/manager/account/permitting-assistance/:permit_id/chats"
              component={PermitChats}
            />

            <DefaultLayout exact path="/manager/account/sgip-incentive" component={SGIPIncentive} />
            <DefaultLayout
              exact
              path="/manager/account/sgip-incentive/new"
              component={SGIPNewApplication}
              hasLeftPane
              withoutFooter
            />
            <DefaultLayout
              exact
              path="/manager/account/sgip-incentive/applications"
              component={SGIPApplications}
              hasLeftPane
              withoutFooter
            />

            {/* dashboard */}
            <DefaultLayout exact path="/manager/dashboard" component={Dashboard} isDashboard={true} />
            <DefaultLayout exact path="/manager/dashboard/area-coverage" component={AreaCoverage} />
            <DefaultLayout exact path="/manager/dashboard/lead-program" component={LeadPreferences} />
            <DefaultLayout exact path="/manager/dashboard/ein-program" component={EinProgram} />
            <DefaultLayout
              exact
              path="/manager/dashboard/labor-protection"
              component={props => <Systems {...props} />}
            />
            <DefaultLayout exact path="/manager/systems/lpp" component={props => <Systems {...props} />} />
            <DefaultLayout
              exact
              path="/manager/dashboard/company"
              component={props => <CompanyProfile isFrom="company" {...props} />}
            />
            <DefaultLayout exact path="/manager/dashboard/branches" component={Branches} />
            <DefaultLayout
              exact
              path="/manager/dashboard/branches/create"
              component={props => <CompanyProfile isFrom="createBranch" {...props} />}
            />
            <DefaultLayout
              exact
              path="/manager/dashboard/branches/:companyId"
              component={props => <CompanyProfile isFrom="editBranch" {...props} />}
            />
            <DefaultLayout exact path="/manager/dashboard/users" component={Users} />
            <DefaultLayout
              exact
              path="/manager/dashboard/users/create"
              component={props => <UserForm isFrom="createUser" {...props} />}
            />
            <DefaultLayout
              exact
              path="/manager/dashboard/users/:userId"
              component={props => <UserForm isFrom="editUser" {...props} />}
            />
            <DefaultLayout exact path="/manager/dashboard/preferences" component={Preferences} />
            <DefaultLayout exact path="/manager/dashboard/api-access" component={APIAccess} />
            <DefaultLayout exact path="/manager/dashboard/third-party-reporting" component={ThirdPartyReporting} />
            <DefaultLayout exact path="/manager/dashboard/account-details" component={AccountDetails} />
            <DefaultLayout exact path="/manager/dashboard/profiles" component={GridProfile} />
            <DefaultLayout exact path="/manager/dashboard/companies/:companyId/users" component={Users} />
            <DefaultLayout
              exact
              path="/manager/dashboard/:source_id/permitting-assistance/:permit_id"
              component={props => <PermittingAssistance {...props} />}
              hasLeftPane
              withoutFooter
            />
            <DefaultLayout
              exact
              path="/manager/dashboard/permitting-assistance/:permit_id"
              component={props => <PermittingAssistance {...props} />}
              hasLeftPane
              withoutFooter
            />
            <DefaultLayout exact path="/manager/dashboard/permitting-assistance" component={PermittingListing} />
            <DefaultLayout
              exact
              path="/manager/dashboard/permitting-assistance/:permit_id/chats"
              component={PermitChats}
            />
            <DefaultLayout
              exact
              path="/manager/dashboard/activations"
              component={ActivationUI}
              hasLeftPane
              withoutFooter
            />

            <DefaultLayout
              exact
              path="/manager/dashboard/activations/:source_id"
              component={ActivationUI}
              hasLeftPane
              withoutFooter
            />

            <DefaultLayout exact path="/manager/dashboard/sgip-incentive" component={SGIPIncentive} />
            <DefaultLayout
              exact
              path="/manager/dashboard/sgip-incentive/new"
              component={SGIPNewApplication}
              hasLeftPane
              withoutFooter
            />
            <DefaultLayout
              exact
              path="/manager/dashboard/sgip-incentive/applications"
              component={SGIPApplications}
              hasLeftPane
              withoutFooter
            />
            <DefaultLayout exact path="/manager/dashboard/bom" component={BOM} withoutFooter />
            <DefaultLayout exact path="/manager/dashboard/modem-replacement" component={ModemReplacement} withoutFooter />
            <DefaultLayout exact path="/manager/dashboard/rma-dashboard" component={RMADashboard} />
            <DefaultLayout exact path="/manager/dashboard/generator-tokens" component={GeneratorTokensInstaller} />
            <DefaultLayout exact path="/manager/dashboard/data-plan-extension" component={CellModemDataPlanExtension} />
            <DefaultLayout exact path="/manager/dashboard/pronto" component={Pronto} />
            <DistributorLayout exact path="/manager/dashboard/distributor-dashboard" component={GeneratorTokensDistributor} />

            <DigiCore exact path="/manager/dashboard/:companyId/leads" component={LeadListing} />
            <DigiCore
              exact
              path="/manager/dashboard/:companyId/leads/:leadId"
              component={LeadView}
              hasLeftPane
              withoutFooter
            />
            <DigiCore
              exact
              path="/manager/dashboard/:companyId/leads/create-lead"
              component={LeadView}
              hasLeftPane
              withoutFooter
            />
            <AdminLayout exact path="/manager/admin/platform-discounts" component={PlatformDiscounts} />

            <DefaultLayout exact path="/manager/dashboard/ein-dashboard" component={EinDashboard} />
            <DefaultLayout exact path="/manager/dashboard/error" component={ErrorComponent} />

            <DefaultLayout exact path="/manager/admin" component={AdminNew} withoutFooter hideBreadcrumb />
            <DefaultLayout exact path="/manager/admin/:section" component={AdminNew} withoutFooter hideBreadcrumb />
            <DefaultLayout
              exact
              path="/manager/admin/enlighten-notices/create"
              component={props => <AdminNew isFrom="createEnlightenNotice" {...props} />}
              withoutFooter
              hideBreadcrumb
            />
            <DefaultLayout exact path="/manager/dashboard/leads/:leadJourneyId" component={RedirectToLeadView} />
            <DefaultLayout exact path="/manager/dashboard/design-tool" component={SGMarketingPage} />
            <DefaultLayout exact path="/manager/dashboard/my-training" component={TrainingDashboard} />
            <DefaultLayout exact path="/manager/account/my-training" component={TrainingDashboard} />
            <DefaultLayout exact path={FLEET_DASHBOARD_URL} component={FleetDashboard} />
            <ThirdPartyAdmin
              exact
              path="/manager/admin/merchandise-credit/:countryCode"
              component={MerchandiseCredit}
            />

            <LoginLayout exact path="/manager/registration" component={Registration} />
            <DefaultLayout exact path="/manager/dashboard/commercial" component={CommercialShortcuts} withoutFooter />
            <ExternalLayout exact path="/manager/external/systems/:siteId/:replacementType"  component={DeviceReplacement}  />
            <DefaultLayout component={NoMatch} />
          </Switch>
        </Suspense>
      </Router>
    );
  }
}
